import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Impressum";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/impressum")({
  head: () => pageHead("/impressum"),
  component: Page,
});
